import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e366fde"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e366fde')) {
      api.createRecord('4e366fde', component.options)
    } else {
      api.reload('4e366fde', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4e366fde", function () {
      api.rerender('4e366fde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/pages/leads/index.vue"
export default component.exports